import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getOCRScanner, setPaymentServiceData, setTelcelPrepagoPaymentServiceData, setNumberContact, 
  setOCRScannerData, getPaymentContacts,getFavoriteContacts, addContactToFavorites, 
  deleteContactFromFavorites, getRecentContacts, addContactToRecents
} from '../../store/actions';
import { selectPaymentServiceConfArrayServices, selectOCRScannerData, selectPaymentServiceContacts, selectContactNumberData } from '../../store/selectors/paymentsSelectors'
import GenericForm from '../organisms/GenericForm'
import ClaroList from '../organisms/ClaroList'
import { GenericFormContextProvider } from '../../context/genericFormContext';
import  ClaroVideoCarousel  from '../molecules/ClaroVideoCarousel'

class ServicePaymentContainer extends Component {


  constructor(props) {
    super(props)

    this.state = {
      claroListDisplay: "none",
      claroFormDisplay: "block",
      valueContact: null,
      dataContact: [],
      index: 0,
      renderCarousel: false,
      serviceConfig : this.props.paymentsConfigArrayServices[this.props.serviceIndex]
    }
  }

  componentDidMount() {
    
    const serviceInfo = this.state.serviceConfig.serviceData.info;    
    
    
    if(serviceInfo.permissions && serviceInfo.permissions.contactList ){
      this.props.getFavoriteContacts(serviceInfo.serviceId);
      this.props.getRecentContacts(serviceInfo.serviceId);
    }
  
    if(serviceInfo.logicType && serviceInfo.logicType == "claroVideo"){
      this.setState({renderCarousel: true})
      setInterval(() => {
        let indexAutoplay = this.state.index
        if(indexAutoplay >= 4){
          indexAutoplay = -1;
        }
        this.setState({index: indexAutoplay + 1});
      }, 3500)
    }
    window.bandera =3;
  }


  changeDisplay = (click) => {
    if (click == "form") {
      const serviceInfo = this.state.serviceConfig.serviceData.info; 
      this.props.getFavoriteContacts(serviceInfo.serviceId);
      this.props.getRecentContacts(serviceInfo.serviceId);
      setTimeout(
        () => {
          this.setState({
            claroListDisplay: "block",
            claroFormDisplay: "none",
          })
        }, 
        200
      );
      ;
    }
    if (click == "contact") {
      this.setState({
        claroListDisplay: "none",
        claroFormDisplay: "block",
      })
    }
  }

  updateForm = (data) => {
    var { setNumberContact } = this.props
    var number = null;
    try {
      let str = data.telephoneNumber.match(/\d/g).join("")
      number = str.substring(str.length - 10, str.length)
    } catch (e) {
      console.log(e)
    }
    
    this.setState({
      claroListDisplay: "none",
      claroFormDisplay: "block",
      dataContact: data
    })
    
    setNumberContact(number)
  }

  handleAddContactToFavorites = (contact, serviceId) => {

    this.props.addContactToFavorites(contact, serviceId)
  }

  handleDeleteContactFromFavorites = (contact, serviceId) => {
    this.props.deleteContactFromFavorites(contact, serviceId);
  }

  postChange = (e)=> {
    if(e.activeIndex > 4){
      this.setState({index: 4})
    }else{
      this.setState({index: e.activeIndex})
    }
  }

  handleCheck= (e) =>{
    this.setState({index: e.target.id})
  }



  render() {

    var { serviceIndex, paymentsConfigArrayServices, contactsList, favoriteContacts, recentContacts } = this.props

    let element = paymentsConfigArrayServices[serviceIndex]

    let carousel = "";
    if(this.state.renderCarousel){
      carousel = <ClaroVideoCarousel postChange={this.postChange} index={this.state.index} handleCheck={this.handleCheck}></ClaroVideoCarousel>

    }

    if (element && Object.getOwnPropertyNames(element).length >= 1) {

      let { serviceData: { info, generic } } = element

      if (this.state.claroListDisplay === "block" && !this.props.isLoading) {
        return <div style={{ display: `${this.state.claroListDisplay}` }} >
            <GenericFormContextProvider>

            <ClaroList
              serviceId={this.props.payments.PAYMENT_SERVICE_CONF.services[this.props.serviceIndex].serviceData.info.serviceId}
              contactsList={contactsList}
              favoriteContacts={favoriteContacts}
              recentContacts={recentContacts}
              title="Contactos"
              changeDisplay={this.changeDisplay}
              updateForm={this.updateForm}
              handleAddContactToFavorites={this.handleAddContactToFavorites}
              handleDeleteContactFromFavorites={this.handleDeleteContactFromFavorites}
              
            />
          </GenericFormContextProvider>
        </div>
      }

      return (
        <div style={{ display: `${this.state.claroFormDisplay}`, height: "95%", overflow: "auto"}} >
          <GenericFormContextProvider>
            <GenericForm
              changeDisplay={this.changeDisplay}
              {...this.props}
              {...generic}
              {...info}
              setPaymentServiceData={this.props.setPaymentServiceData}
              serviceKey = {this.props.serviceIndex}
              serviceId={this.props.payments.PAYMENT_SERVICE_CONF.services[this.props.serviceIndex].serviceData.info.serviceId}
              dataContact= {this.state.dataContact}
              addContactToRecents = {this.props.addContactToRecents}
              contactsList={contactsList}
              sdkVersion = {this.props.sdkVersion}
            />
          </GenericFormContextProvider>
          {carousel}
        </div>
      )
    }
    return <div>Config not found...</div>

  }
}


function mapStateToProps(state) {
  const { payments } = state;

  const paymentsConfigArrayServices = selectPaymentServiceConfArrayServices(payments);
  const ocrScannerData = selectOCRScannerData(payments)
  const contactsList = selectPaymentServiceContacts(payments)
  const contactNumber = selectContactNumberData(payments)
  return {
    paymentsConfigArrayServices,
    ocrScannerData,
    contactsList,
    contactNumber,
    isLoading: state.payments.isLoading,
    payments: state.payments,
    favoriteContacts: state.payments.favoriteContacts,
    recentContacts: state.payments.recentContacts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getOCRScanner,
      setPaymentServiceData,
      setTelcelPrepagoPaymentServiceData,
      getPaymentContacts,
      setNumberContact,
      setOCRScannerData,
      getFavoriteContacts,
      addContactToFavorites,
      deleteContactFromFavorites,
      getRecentContacts,
      addContactToRecents
    },
    dispatch,
  );
}

ServicePaymentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicePaymentContainer);


export default ServicePaymentContainer